import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { FunktionsbereicheRollenPage } from './funktionsbereiche-rollen.page';
import { SopiScrollModule } from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import { StoreModule } from '@ngrx/store';
import { reducers } from './funktionsbereiche-rollen.reducer';
import { EffectsModule } from '@ngrx/effects';
import { FunktionsbereichRollenPageUiEffects } from './funktionsbereiche-rollen.effects.ui';
import {
  BenutzerverwaltungFunktionsbereichAdminEntfernenEffects,
  BenutzerverwaltungFunktionsbereichAdminHinzufuegenEffects,
  BenutzerverwaltungFunktionsbereichAdminsEffects,
  BenutzerverwaltungFunktionsbereichAnlegenEffects,
  BenutzerverwaltungFunktionsbereichDetailEffects,
  BenutzerverwaltungFunktionsbereicheEffects,
  BenutzerverwaltungFunktionsbereichEMailBenachrichtigungBereitschaftEffects,
  BenutzerverwaltungFunktionsbereichEMailBenachrichtigungFehlerfallEffects,
  BenutzerverwaltungFunktionsbereichExpliziteFreigabeFestlegenEffects,
  BenutzerverwaltungFunktionsbereichFreigabeBerechtigungRolleEntfernenEffects,
  BenutzerverwaltungFunktionsbereichFreigabeBerechtigungRolleHinzufuegenEffects,
  BenutzerverwaltungFunktionsbereichFreigabeRollenEffects, BenutzerverwaltungFunktionsbereichLoeschenEffects,
  BenutzerverwaltungFunktionsbereichRollenEffects,
  BenutzerverwaltungFunktionsbereichUmbenennenEffects,
  BenutzerverwaltungRolleAnlegenEffects,
  BenutzerverwaltungRolleDetailEffects,
  BenutzerverwaltungRolleDienstplanSichtbarkeitFestlegenEffects,
  BenutzerverwaltungRolleVeranstaltungHomeSichtbarkeitFestlegenEffects,
  BenutzerverwaltungRolleExternerAnsprechpartnerFestlegenEffects,  
  BenutzerverwaltungRolleLoeschenEffects,
  BenutzerverwaltungRolleUmbenennenEffects
} from '../../../client-ngrx/benutzerverwaltung';
import { EffectsWs } from './funktionsbereiche-rollen.effects.ws';
import {KommunikationMitteilungsVorlageAktualisierenEffects, KommunikationMitteilungsVorlageAnlegenEffects, KommunikationMitteilungsVorlageDetailEffects, KommunikationMitteilungsVorlageEntfernenEffects, KommunikationRolleMitteilungOptionenEffects, KommunikationRolleMitteilungOptionenFestlegenEffects, KommunikationRolleMitteilungsVorlageListeEffects} from '../../../client-ngrx/kommunikation';
import {
  IncidentsFunktionsbereichAbteilungEffects, IncidentsFunktionsbereichAbteilungSetzenEffects, IncidentsIncidentsRolleBerechtigungEffects,
  IncidentsRolleAbteilungEffects, IncidentsRolleAbteilungSetzenEffects, IncidentsRolleZentraleEffects, IncidentsRolleZentraleSetzenEffects, IncidentsIncidentsRolleBerechtigungenSetzenEffects
} from '../../../client-ngrx/incidents';
import { SopiComponentsModule } from '../../shared/sopi-components/sopi-components.module';
import { EinlasskontrolleEinlasskontrolleRolleBerechtigungSetzenEffects, EinlasskontrolleEinlasskontrolleRolleEffects } from '../../../client-ngrx/einlasskontrolle';
import { DisplaysteuerungDisplaysteuerungRolleBerechtigungEffects, DisplaysteuerungDisplaysteuerungRolleBerechtigungenSetzenEffects } from '../../../client-ngrx/displaysteuerung';
import {QschecksQsChecksRolleBerechtigungEffects, QschecksQsChecksRolleBerechtigungenSetzenEffects} from '../../../client-ngrx/qschecks';
import {VeranstaltungenVeranstaltungBenutzerverwaltungRolleBerechtigungenEffects, VeranstaltungenVeranstaltungenBenutzerverwaltungRolleBerechtigungenSetzenEffects} from '../../../client-ngrx/veranstaltungen';

const routes: Routes = [
  {
    path: '',
    component: FunktionsbereicheRollenPage,
    data: { title: 'Funktionsbereiche und Rollen' }
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),

    StoreModule.forFeature('FunktionsbereicheRollenPage', reducers),
    EffectsModule.forFeature([
      // UI
      FunktionsbereichRollenPageUiEffects,

      // WS
      EffectsWs,

      // GET
      BenutzerverwaltungFunktionsbereichAdminsEffects,
      BenutzerverwaltungFunktionsbereichAdminsEffects,
      BenutzerverwaltungFunktionsbereichDetailEffects,
      BenutzerverwaltungFunktionsbereicheEffects,
      BenutzerverwaltungFunktionsbereichFreigabeRollenEffects,
      BenutzerverwaltungFunktionsbereichRollenEffects,
      BenutzerverwaltungRolleDetailEffects,
      KommunikationRolleMitteilungOptionenEffects,
      IncidentsFunktionsbereichAbteilungEffects,
      IncidentsRolleZentraleEffects,
      IncidentsRolleAbteilungEffects,
      EinlasskontrolleEinlasskontrolleRolleEffects,
      DisplaysteuerungDisplaysteuerungRolleBerechtigungEffects,
      IncidentsIncidentsRolleBerechtigungEffects,
      QschecksQsChecksRolleBerechtigungEffects,

      // POST
      BenutzerverwaltungFunktionsbereichAdminEntfernenEffects,
      BenutzerverwaltungFunktionsbereichAnlegenEffects,
      BenutzerverwaltungFunktionsbereichEMailBenachrichtigungBereitschaftEffects,
      BenutzerverwaltungFunktionsbereichEMailBenachrichtigungFehlerfallEffects,
      BenutzerverwaltungFunktionsbereichExpliziteFreigabeFestlegenEffects,
      BenutzerverwaltungFunktionsbereichFreigabeBerechtigungRolleEntfernenEffects,
      BenutzerverwaltungFunktionsbereichUmbenennenEffects,
      BenutzerverwaltungRolleAnlegenEffects,
      BenutzerverwaltungRolleDienstplanSichtbarkeitFestlegenEffects,
      BenutzerverwaltungRolleVeranstaltungHomeSichtbarkeitFestlegenEffects,
      BenutzerverwaltungRolleExternerAnsprechpartnerFestlegenEffects,
      BenutzerverwaltungRolleLoeschenEffects,
      BenutzerverwaltungRolleUmbenennenEffects,
      BenutzerverwaltungFunktionsbereichFreigabeBerechtigungRolleHinzufuegenEffects,
      BenutzerverwaltungFunktionsbereichAdminHinzufuegenEffects,
      BenutzerverwaltungFunktionsbereichLoeschenEffects,
      KommunikationRolleMitteilungOptionenFestlegenEffects,
      IncidentsFunktionsbereichAbteilungSetzenEffects,
      IncidentsRolleZentraleSetzenEffects,
      IncidentsRolleAbteilungSetzenEffects,
      EinlasskontrolleEinlasskontrolleRolleBerechtigungSetzenEffects,
      IncidentsIncidentsRolleBerechtigungenSetzenEffects,
      DisplaysteuerungDisplaysteuerungRolleBerechtigungenSetzenEffects,
        QschecksQsChecksRolleBerechtigungenSetzenEffects,
        KommunikationRolleMitteilungsVorlageListeEffects,
        KommunikationMitteilungsVorlageDetailEffects,
        KommunikationMitteilungsVorlageAnlegenEffects,
        KommunikationMitteilungsVorlageAktualisierenEffects,
        KommunikationMitteilungsVorlageEntfernenEffects,

        VeranstaltungenVeranstaltungBenutzerverwaltungRolleBerechtigungenEffects,
        VeranstaltungenVeranstaltungenBenutzerverwaltungRolleBerechtigungenSetzenEffects
    ]),
    ReactiveFormsModule,
    SopiScrollModule,
    SopiComponentsModule.forRoot()
  ],
  declarations: [FunktionsbereicheRollenPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FunktionsbereicheRollenPageModule {
}
